import React from 'react';

const PermissionGuard2 = ({ children }) => {
    return <>{children}</>;
};

export default PermissionGuard2;
